var icon = require('vue-svgicon')
icon.register({
  'fontawesome/git': {
    width: 1792,
    height: 1792,
    viewBox: '0 0 1792 1792',
    data: '<path pid="0" d="M595 1514q0-100-165-100-158 0-158 104 0 101 172 101 151 0 151-105zm-59-755q0-61-30-102t-89-41q-124 0-124 145 0 135 124 135 119 0 119-137zm269-324v202q-36 12-79 22 16 43 16 84 0 127-73 216.5T472 1072q-40 8-59.5 27t-19.5 58q0 31 22.5 51.5t58 32 78.5 22 86 25.5 78.5 37.5 58 64T797 1488q0 304-363 304-69 0-130-12.5t-116-41-87.5-82T68 1529q0-165 182-225v-4q-67-41-67-126 0-109 63-137v-4q-72-24-119.5-108.5T79 759q0-139 95-231.5T409 435q96 0 178 47 98 0 218-47zm318 881H901q4-45 4-134V573q0-94-4-128h222q-4 33-4 124v613q0 89 4 134zm601-222v196q-71 39-174 39-62 0-107-20t-70-50-39.5-78-18.5-92-4-103V635h2v-4q-7 0-19-1t-18-1q-21 0-59 6V445h96v-76q0-54-6-89h227q-6 41-6 165h171v190q-15 0-43.5-2t-42.5-2h-85v365q0 131 87 131 61 0 109-33zm-576-947q0 58-39 101.5t-96 43.5q-58 0-98-43.5T875 147q0-59 39.5-103T1013 0q58 0 96.5 44.5T1148 147z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/generated_svg_icons/fontawesome/git.js